<template>
  <div
    class="box"
    :style="{height: boxH}"
  >
    <!--上: 头部-->
    <div
      v-if="!isFullScreen"
      class="box-header"
      :style="{height: `${boxHeaderH}px`, 'padding-right': `${boxMarginR}px`, 'padding-left': `${boxMarginL}px`}"
    >
      <slot name="boxHeader" />
    </div>
    <!--中：中间区域-->
    <div
      class="box-body"
      :style="{height: boxBodyH}"
    >
      <!--右： 右侧栏-->
      <transition name="slide-fade">
        <div
          v-show="openRightPanel"
          class="box-body-right"
          :style="{width: `${boxRightW}px`}"
        >
          <slot name="boxRight" />
        </div>
      </transition>
      <!--左： 主要的可视区-->
      <div
        class="box-body-left common-transion"
        :style="{'margin-Right': openRightPanel ? `${boxRightW}px` : 0}"
      >
        <slot name="boxBody" />
      </div>
    </div>
    <!--下： 底部-->
    <div
      v-if="hasBoxFooter"
      class="box-footer"
      :style="{height: `${boxFooterH}px`}"
    >
      <slot name="boxFooter" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    /**
         * 头部的高度
         */
    boxHeaderH: {
      type: Number,
      default: 50,
    },
    /**
         * footer的高度
         */
    boxFooterH: {
      type: Number,
      default: 50,
    },
    /**
         * 右侧栏的宽度
         */
    boxRightW: {
      type: Number,
      default: 288,
    },
    /**
         * 右边距
         * 单文件外链：左20px右20px
         * 文件夹外链：左60px右60px
         * 文件夹里的文件预览：左20px右20px
         * 外链失效等异常页面：左60px右60px
         * 提取码页面：左60px右60px
         */
    boxMarginR: {
      type: Number,
      default: 20,
    },
    /**
         * 左边距
         * 同上
         */
    boxMarginL: {
      type: Number,
      default: 20,
    },
    /**
         * 头部提示（如eod）的高度，为0 则不显示
         */
    boxTipH: {
      type: Number,
      default: 0,
    },
    /**
         * 是否有底部，目前这个需求中没有，但是如果后期加，可以把此值设为true
         */
    hasBoxFooter: {
      type: Boolean,
      default: false,
    },
    /**
         * 切换右侧栏
         */
    displayRight: {
      type: Boolean,
      default: false,
    },
    /**
         * 是否为全屏
         */
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    /**
         * 是否为三方审批外链
         */
    isShowThirdHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    /**
         * 总高
         */
    boxH() {
      if (this.isFullScreen) return '100%'
      if (this.boxTipH > 0) return `calc(100% - ${this.boxTipH}px)`
      return '100%'
    },
    /**
         * 中间body的高
         */
    boxBodyH() {
      if (this.isFullScreen) return '100%'
      if (!this.hasBoxFooter) return `calc(100% - ${this.boxHeaderH}px)`
      return `calc(100% - ${this.boxHeaderH + this.boxFooterH}px)`
    },
    /**
         * toggle右侧栏，全屏下取消右侧栏
         */
    openRightPanel() {
      if (!this.isShowThirdHeader) {
        return false
      }
      return this.displayRight && !this.isFullScreen
    },
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
.box{
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  .common-transion{
    transition: all 0.4s ease;
  }
  .box-header{
    width: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.15);
    position: relative;
    z-index: 80;
  }
  .box-body{
    width: 100%;
    overflow: hidden;
    zoom: 1;
  }
  .box-footer{
    width: 100%;
  }
  .box-body-left {
    height: 100%;
    position: relative;
  }
  .box-body-right {
    float: right;
    height: 100%;
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    //transform: translateX(300px);
    opacity: 0;
  }
}
</style>
